import { LocalLibrary as LocalLibraryIcon } from "@mui/icons-material/";
import { Tour as TourIcon } from "@mui/icons-material/";
import { Equalizer as EqualizerIcon } from "@mui/icons-material/";
import { Portrait as PortraitIcon } from "@mui/icons-material/";
import { NotificationsActive as NotificationsActiveIcon } from "@mui/icons-material/";

import FranchiseeLoginMenuList from "./FranchiseeLoginMenuList";

const FranchiseeUserAccessMenu = (menus: any) => {
  let drawerMenus: any[] = [];
  drawerMenus.push(FranchiseeLoginMenuList.DASHBOARD);
  menus &&
    menus.forEach((menu: any) => {
      switch (menu.menuName) {
        case "MASTER": {
          drawerMenus.push({
            name: "Master",
            icon: <PortraitIcon />,
            subMenu: createSubMenus(menu.menuName, menu.subMenu),
          });
          break;
        }
        case "STUDENT": {
          drawerMenus.push({
            name: "Student",
            icon: <LocalLibraryIcon />,
            subMenu: createSubMenus(menu.menuName, menu.subMenu),
          });
          break;
        }
        case "PURCHASE": {
          drawerMenus.push({
            name: "Purchase",
            icon: <TourIcon />,
            subMenu: createSubMenus(menu.menuName, menu.subMenu),
          });
          break;
        }
        case "REPORTS": {
          drawerMenus.push({
            name: "Reports",
            icon: <EqualizerIcon />,
            subMenu: createSubMenus(menu.menuName, menu.subMenu),
          });
          break;
        }
        case "NOTIFICATION": {
          drawerMenus.push({
            name: "Notifications",
            icon: <NotificationsActiveIcon />,
            subMenu: createSubMenus(menu.menuName, menu.subMenu),
          });
          break;
        }
      }
    });

  return drawerMenus;
};

const createSubMenus = (menuName: string, subMenu: any) => {
  let drawerSubMenus: any[] = [];
  subMenu &&
    subMenu?.forEach((subMenuItem: any) => {
      drawerSubMenus.push(
        FranchiseeLoginMenuList[menuName]?.find(
          (subMenu: any) => subMenu?.name === subMenuItem.subMenuDisplayName
        )
      );
    });
  return drawerSubMenus;
};
export default FranchiseeUserAccessMenu;
